import { put } from 'redux-saga/effects';
import { apiPost } from 'shared/api';
import * as actions from 'store/actions';
import { fetchUserProfile } from 'store/thunks';

export function* fetchLogsDetailsSaga(action) {
  try {
    const data = {};
    if (action.isManagedUser) {
      data.UserId = action.UserId;
    }
    const response = yield apiPost('v2_logDetails', data);
    const logs = yield response.data.payload.Logs;

    yield put(actions.fetchLogsDetailsSuccess(logs));
  } catch (error) {
    yield put(actions.fetchLogsDetailsFailed(error.response.data.error_message));
  }
}

export function* fetchTagsForLogsSaga(action) {
  yield put(actions.fetchTagsStart());
  try {
    const data = {};
    if (action.LogId !== null) {
      data.LogId = action.LogId;
    }
    const response = yield apiPost('v2_tagsGetForLogs', data);
    const logs = yield response.data.payload.Logs;
    yield put(actions.fetchTagsSuccess(logs));
  } catch (error) {
    yield put(actions.fetchTagsFailed(error.response.data.error_message));
  }
}

export function* fetchMembersForLogsSaga() {
  yield put(actions.fetchMembersForLogsStart());
  try {
    const response = yield apiPost('v2_userWhosWho', {});
    const logs = yield response.data.payload.Logs;
    yield put(actions.fetchMembersForLogsSuccess(logs));
  } catch (error) {
    yield put(actions.fetchMembersForLogsFailed(error.response.data.error_message));
  }
}

export function* fetchLogSaga(action) {
  const pageNum = action.Page ? action.Page : 1;
  yield put(actions.fetchLogStart(pageNum, action.PageFilterLogId));
  try {
    const data = {
      Page: pageNum,
    };
    if (action.PageFilterLogId) {
      data.PageFilterLogId = action.PageFilterLogId;
    }
    if (action.UserId) {
      data.UserId = action.UserId;
    }
    if (action.MyHistory) {
      data.MyHistory = true;
    }
    if (action.ShowLogs) {
      data.ShowLogs = true;
    }
    if (action.ShowTags) {
      data.ShowTags = true;
    }
    if (action.PageSize) {
      data.PageSize = action.PageSize;
    }
    if (action.SortBy) {
      data.SortBy = action.SortBy;
    }
    if (action.PageFilterCat) {
      data.PageFilterCat = action.PageFilterCat;
    }
    if (action.PageFilterTag) {
      data.PageFilterTag = action.PageFilterTag;
    }
    if (action.PageFilterLogId) {
      data.PageFilterLogId = action.PageFilterLogId;
    }
    if (action.PageFilterUserId) {
      data.PageFilterUserId = action.PageFilterUserId;
    }
    if (action.PageFilterKeyword) {
      data.PageFilterKeyword = action.PageFilterKeyword;
    }
    if (action.PageFilterDateRange) {
      data.PageFilterDateRange = action.PageFilterDateRange;
    }
    if (action.PageFilterLocation) {
      data.PageFilterLocation = action.PageFilterLocation;
    }
    if (action.PageFilterFileType) {
      data.PageFilterFileType = action.PageFilterFileType;
    }
    if (action.PageFilterSeason) {
      data.PageFilterSeason = action.PageFilterSeason;
    }
    if (action.PageFilterRead === true) {
      data.PageFilterRead = 'unread_me';
    }
    console.log('fetchLogSaga - data', data);
    let response = null;
    if (action.PageFilterLogId) {
      const apiEndpoint = yield action.ViewType === 'GalleryAllImages' ? 'v2_userLogGalleryView' : 'v2_userLogAllPosts';
      data.ShowTotalResultCount = true;
      response = yield apiPost(apiEndpoint, data);
      yield put(
        actions.fetchLogSuccess(
          action.PageFilterLogId.split('|'),
          response.data.payload.Posts,
          response.data.payload.TotalResultCount,
          response.data.payload.Page,
          response.data.payload.Categories,
          response.data.payload.Users,
          action.PageSize,
        ),
      );
    } else {
      yield put(actions.fetchLogSuccess(null, [], 0, 1, [], [], null));
    }
  } catch (error) {
    yield put(actions.fetchLogFailed(error.response.data.error_message));
  }
}

export function* fetchMultiViewColumnSaga(action) {
  yield put(actions.fetchMultiViewColumnsStart(action.ColumnType, action.ColumnNames, action.PageNum));
  try {
    const data = {
      Page: action.PageNum,
    };
    // The difference between the data object sent for the category and people views
    // is the name of the action.ColumnType property 'Type' vs 'ForUsers'
    if (action.ColumnType === 'categories') {
      data.Type = action.ColumnNames.join(',');
    } else {
      data.ForUsers = action.ColumnNames.join(',');
    }
    if (action.PageFilterLogId) {
      data.PageFilterLogId = action.PageFilterLogId;
    }
    if (action.UserId) {
      data.UserId = action.UserId;
    }
    if (action.MyHistory) {
      data.MyHistory = true;
    }
    if (action.ShowLogs) {
      data.ShowLogs = true;
    }
    if (action.ShowTags) {
      data.ShowTags = true;
    }
    if (action.PageSize) {
      data.PageSize = action.PageSize;
    }
    if (action.SortBy) {
      data.SortBy = action.SortBy;
    }
    if (action.PageFilterCat) {
      data.PageFilterCat = action.PageFilterCat;
    }
    if (action.PageFilterTag) {
      data.PageFilterTag = action.PageFilterTag;
    }
    if (action.PageFilterLogId) {
      data.PageFilterLogId = action.PageFilterLogId;
    }
    if (action.PageFilterUserId) {
      data.PageFilterUserId = action.PageFilterUserId;
    }
    if (action.PageFilterKeyword) {
      data.PageFilterKeyword = action.PageFilterKeyword;
    }
    if (action.PageFilterDateRange) {
      data.PageFilterDateRange = action.PageFilterDateRange;
    }
    if (action.PageFilterLocation) {
      data.PageFilterLocation = action.PageFilterLocation;
    }
    if (action.PageFilterFileType) {
      data.PageFilterFileType = action.PageFilterFileType;
    }
    if (action.PageFilterSeason) {
      data.PageFilterSeason = action.PageFilterSeason;
    }
    if (action.PageFilterRead === true) {
      data.PageFilterRead = 'unread_me';
    }
    const apiEndpoint = yield action.ColumnType === 'categories' ? 'v3_userLogMultiView' : 'v3_userLogMultiViewByUser';
    const response = yield apiPost(apiEndpoint, data);
    const columnsArray = action.ColumnType === 'categories' ? response.data.payload.Types : response.data.payload.Users;
    yield put(actions.fetchMultiViewColumnsSuccess(action.ColumnType, action.ColumnNames, columnsArray, action.PageNum, action.PageSize));
  } catch (error) {
    yield put(actions.fetchMultiViewColumnsFailed(error.response.data.error_message, action.ColumnType, action.ColumnNames));
  }
}

export function* fetchDraftsSaga(action) {
  yield put(actions.fetchDraftsStart());
  try {
    const data = { ShowTotalResultCount: true };
    if (action.isManagedUser === true) {
      data.UserId = action.UserId;
    }
    if (action.SortBy) {
      data.SortBy = action.SortBy;
    }
    if (action.Page) {
      data.Page = action.Page;
    }
    if (action.PageSize) {
      data.PageSize = action.PageSize;
    }
    if (action.PageFilter) {
      data.PageFilter = action.PageFilter;
    }
    const response = yield apiPost('v3_draftGetAll', data);
    yield put(actions.fetchDraftsSuccess(response.data.payload.Posts, response.data.payload.Page, response.data.payload.TotalResultCount));
  } catch (error) {
    yield put(actions.fetchDraftsFailed(error));
  }
}

export function* createLogSaga(action) {
  yield put(actions.createLogStart());
  try {
    const data = {
      Name: action.Name,
      Visibility: action.Visibility ? action.Visibility : 'InviteOnly',
    };
    if (action.isManagedUser === true) {
      data.UserId = action.UserId;
    }
    yield apiPost('v2_logCreate', data);
    yield put(actions.createLogSuccess());
    const signedInAsSameAsPostingAs = yield JSON.parse(localStorage.getItem('signedInAs')).UserId
      ? JSON.parse(localStorage.getItem('signedInAs')).UserId === action.UserId
      : false;
    yield put(fetchUserProfile(action.isManagedUser, action.UserId, 'postingAs', signedInAsSameAsPostingAs));
    yield put(fetchUserProfile(false, undefined, 'signedInAs', signedInAsSameAsPostingAs));
  } catch (error) {
    yield put(actions.createLogFailed(error.response.data.error_message));
  }
}

export function* logUpdateSaga(action) {
  yield put(actions.logUpdateStart());
  try {
    const data = {
      LogId: action.LogId,
      Name: action.Name,
    };
    if (action.Delete === true) {
      data.Delete = 'true';
    }
    const response = yield apiPost('v2_logUpdate', data);
    yield put(actions.logUpdateSuccess(response.data.payload.LogId, !!response.data.payload.Deleted, action.Name));
    const signedInAsSameAsPostingAs = yield JSON.parse(localStorage.getItem('signedInAs')).UserId
      ? JSON.parse(localStorage.getItem('signedInAs')).UserId === action.UserId
      : false;
    yield put(fetchUserProfile(!!action.isManagedUser, action.postingAsUserId, 'signedInAs', signedInAsSameAsPostingAs));
  } catch (error) {
    yield put(actions.logUpdateFailed(error.response.data.error_message));
  }
}

export function* logAddRemoveMembersSaga(action) {
  yield put(actions.logAddRemoveMembersStart());
  try {
    const data = {
      LogId: action.LogId,
    };
    if (action.isManagedUser === true) {
      data.UserId = action.UserId;
    }
    if (action.InviteUsersIds) {
      data.InviteUsers = action.InviteUsersIds.toString();
    }
    if (action.InviteUsersEmails) {
      data.InviteEmails = action.InviteUsersEmails.toString();
    }
    if (action.RemoveUsersIds) {
      data.RemoveUsers = action.RemoveUsersIds.toString();
    }
    if (action.InviteMessage) {
      data.InviteMessage = action.InviteMessage;
    }
    if (typeof action.KeepPosts === 'boolean') {
      data.KeepPosts = action.KeepPosts ? 'Keep' : 'Remove';
    }
    const response = yield apiPost('v2_logAddRemoveUsers', data);
    yield put(actions.logAddRemoveMembersSuccess(response.data.payload.Added, response.data.payload.Removed));
    yield put(actions.fetchLogsDetails(action.UserId, action.isManagedUser));
  } catch (error) {
    yield put(actions.logAddRemoveMembersFailed(error.response.data.error_message));
  }
}

export function* logRemoveArchivedUsersSaga(action) {
  yield put(actions.logRemoveArchivedUsersStart());
  try {
    const data = {
      LogId: action.LogId,
      RemoveUsers: action.RemoveUserIds.toString(),
    };
    const response = yield apiPost('v2_logRemoveArchivedUsers', data);
    yield put(actions.logRemoveArchivedUsersSuccess(response.data.payload.Removed, response.data.payload.LogId));
    yield put(actions.fetchLogsDetails(action.UserId, action.isManagedUser));
  } catch (error) {
    yield put(actions.logRemoveArchivedUsersFailed(error.response.data.error_message));
  }
}

export function* logInviteNewUsersSaga(action) {
  yield put(actions.logInviteNewUsersStart());
  try {
    const data = {
      LogId: action.LogId,
    };
    if (action.isManagedUser === true) {
      data.UserId = action.UserId;
    }
    if (action.Name) {
      data.Name = action.Name;
    }
    if (action.Email) {
      data.Email = action.Email;
    }
    if (action.MobileNumber) {
      data.MobileNumber = action.MobileNumber;
    }
    if (action.InviteMessage) {
      data.InviteMessage = action.InviteMessage;
    }
    const response = yield apiPost('v2_logInviteNewUser', data);

    const userAddedToLog = response.data.payload && response.data.payload.UsersInvited === 1;
    // EmailsSent/TextsSent will be 1 if the recipient is not yet a Riza user
    // const invitationSent = response.data.payload && (response.data.payload.EmailsSent === 1 || response.data.payload.TextsSent === 1);
    // userAddedToLog will be true if the invitee was already a Riza user, in that case they are added to the log.
    if (userAddedToLog) {
      yield put(actions.logAddRemoveMembersSuccess(response.data.payload.UsersInvited, response.data.payload.UsersRemoved));
      yield put(actions.fetchLogsDetails(action.UserId, action.isManagedUser));
    } else {
      // We return the invitee so that we can add them to the Add Members list: https://zpl.io/2ZZwKOE
      const invitee = {
        FirstName: action.Name,
        LastName: '',
        InviteType: action.Email ? (action.MobileNumber ? ['Email', 'Text'] : ['Email']) : ['Text'],
      };
      yield put(actions.logInviteNewUsersSuccess(invitee));
    }
  } catch (error) {
    yield put(actions.logInviteNewUsersFailed(error.response.data.error_message));
  }
}

export function* logUpdateUserAccessSaga(action) {
  yield put(actions.logUpdateUserAccessStart());
  try {
    const data = {
      LogId: action.LogId,
      ForUserId: action.ForUserId,
      Access: action.Access,
    };
    yield apiPost('v2_logUpdateUserAccess', data);
    yield put(actions.logUpdateUserAccessSuccess());
    yield put(actions.fetchLogsDetails(action.UserId, action.isManagedUser));
  } catch (error) {
    yield put(actions.logUpdateUserAccessFailed(error.response.data.error_message));
  }
}

export function* logTransferHostSaga(action) {
  yield put(actions.logTransferHostStart());
  try {
    const data = {
      LogId: action.LogId,
      ToUserId: action.ToUserId,
    };
    yield apiPost('v2_logTransferHost', data);
    yield put(actions.logTransferHostSuccess());
    yield put(actions.fetchLogsDetails(action.UserId, action.isManagedUser));
  } catch (error) {
    yield put(actions.logTransferHostFailed(error.response.data.error_message));
  }
}

export function* logLeaveSaga(action) {
  yield put(actions.logLeaveStart());
  try {
    const data = {
      LogId: action.logId,
    };
    if (action.isSelf !== true) {
      data.RemoveUsers = action.RemoveUsersIds.toString();
    }
    if (action.isManagedUser === true) {
      data.UserId = action.UserId;
    }
    const apiEndpoint = action.isSelf ? 'v2_logRemoveSelf' : 'v2_logAddRemoveUsers';
    const response = yield apiPost(apiEndpoint, data);
    yield put(actions.logLeaveSuccess(response.data.payload.UsersRemoved));
    const signedInAsSameAsPostingAs = yield JSON.parse(localStorage.getItem('signedInAs')).UserId
      ? JSON.parse(localStorage.getItem('signedInAs')).UserId === action.UserId
      : false;
    yield put(fetchUserProfile(action.UserId, action.isManagedUser, 'postingAs', signedInAsSameAsPostingAs));
  } catch (error) {
    yield put(actions.logLeaveFailed(error.response.data.error_message));
  }
}
